export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: that.disabled ? 80 : 110,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('INDEX.table_label_production_order_doc_type') || '文档类型',
    field: 'v_payDocFileType',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_fileName') || '文档名称',
    field: 'fileName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.order_doc_uploadByName') || '上传人',
    field: 'uploadByName',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.order_doc_uploadTime') || '上传时间',
    field: 'uploadTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
  },
]
